import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setDeclineNewInvitationsEnabledState', function (choice) {
    var optionState = getStore().currentState;
    optionState.declineNewInvitationsEnabled = choice;
});
//# sourceMappingURL=setDeclineNewInvitationsEnabledState.js.map